var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"toast",class:_vm.toastClass,style:(_vm.toastStyle),on:{"animationend":_vm.handleAnimationEnd}},[_c('div',{staticClass:"toast-content"},[_c('div',{staticClass:"status-dot"}),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }